import { isAddress } from 'viem'
import { z } from 'zod'

const surveyStatusSchema = z.enum(['ongoing', 'upcoming', 'ended'])

const surveyAnswerSchema = z.object({
	id: z.string(),
	totalTokens: z.string(),
	totalVotes: z.string()
})

const surveyDtoSchema = z.object({
	id: z.number(),
	surveyContract: z.string().refine(isAddress),
	question: z.string(),
	answers: z.array(surveyAnswerSchema),
	startDate: z.string().datetime(),
	endDate: z.string().datetime(),
	metadataURL: z.union([z.string().url(), z.string()]),
	totalVotes: z.string(),
	totalTokensUsed: z.string(),
	votingCap: z.string(),
	status: surveyStatusSchema,
	createdAt: z.string(),
	updatedAt: z.string()
})

const surveyResponseDtoSchema = z.object({
	totalPages: z.number(),
	page: z.number(),
	surveys: z.array(surveyDtoSchema)
})

const surveyMetadataSchema = z.object({
	question: z.string(),
	description: z.string(),
	answers: z
		.array(
			z.object({
				id: z.string(),
				text: z.string(),
				imageURL: z.string().optional(),
				videoURL: z.string().optional()
			})
		)
		.min(1),
	isBinding: z.boolean().optional(),
	surveyType: z.enum(['Engagement', 'OtherTypesIfApplicable']).optional(),
	quorum: z.number().optional(),
	publishDate: z.number(),
	disclosedDate: z.number(),
	_votingCap: z.string().optional(),
	InformationURL: z.string().url().optional(),
	bannerURL: z.string().url().optional()
})

const chainSurveyAnswerSchema = z.object({
	id: z.string(),
	totalTokens: z.bigint(),
	totalVotes: z.bigint()
})

const chainSurveySchema = z.object({
	address: z.string().refine(isAddress),
	question: z.string(),
	answers: z.array(chainSurveyAnswerSchema),
	startDate: z.bigint(),
	endDate: z.bigint(),
	totalVotes: z.bigint(),
	totalTokensUsed: z.bigint(),
	votingCap: z.bigint(),
	isOpen: z.boolean(),
	metadataURL: z.union([z.string().url(), z.string()]).optional()
})

const surveyStatsResponseDtoSchema = z.object({
	count: z.object({
		ongoing: z.number(),
		upcoming: z.number(),
		ended: z.number()
	}),
	lastUpdated: z.string().datetime()
})

export {
	surveyStatusSchema,
	surveyDtoSchema,
	surveyResponseDtoSchema,
	surveyAnswerSchema,
	surveyMetadataSchema,
	surveyStatsResponseDtoSchema,
	chainSurveySchema
}
